import React from 'react';
import { CheckIcon } from 'lucide-react';
import { purchaseUrl } from '../data/content';
import { Button } from './ui/Button';
export function FinalCta() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-56" data-mp="vhivm2qc9gay">
      <div className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="19fqnhw8iprf9">
        <h2 className="text-2xl font-black uppercase leading-tight text-ink md:text-4xl" data-id="element-58" data-mp="15ddkvgp2i9mp">
          De cero a 21K. <span className="text-accent" data-id="element-59" data-mp="1jcvc02pu5yz8">Un camino claro para cada objetivo.</span>
        </h2>
        <p className="mt-4 text-base font-black uppercase leading-tight text-primary md:text-xl" data-id="element-60" data-mp="1eebnbujuy936">
          No necesitás seguir buscando qué entrenamiento hacer mañana.
        </p>
        <p className="mt-3 text-sm font-semibold text-slate-600 md:text-base" data-id="element-61" data-mp="1t4rb9h3nrv51">
          Elegí tu objetivo. Abrí tu planificación. Seguí el entrenamiento.
        </p>

        <div className="mt-7" data-id="element-62" data-mp="2245ym7oj3plb">
          <Button href={purchaseUrl} className="w-full text-sm md:w-auto md:text-lg" data-id="element-63" data-mp="2219zwh4uwwvt">
            🏃 Quiero mi Combo Completo Running 2026 →
          </Button>
        </div>

        <p className="mt-4 text-sm font-bold text-slate-600" data-id="element-64" data-mp="n7fehlxhowbz">
          6 tomos + 5 bonos · Acceso digital · Garantía de 7 días
        </p>

        <p className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-slate-500" data-id="element-65" data-mp="x41yy9lwlldh">
          <span className="flex items-center gap-1" data-id="element-66" data-mp="123wnw7m4c0vw">
            <CheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-67" data-mp="120ion88r47so" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-68" data-mp="162m92mdeemq3">
            <CheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-69" data-mp="1b28p13km2h2l" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-70" data-mp="1fvb98l3i0e64">
            <CheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-71" data-mp="1ktd2tzyjvvvu" /> Mercado Pago · Tarjeta ·
            Transferencia
          </span>
        </p>
      </div>
    </section>;
}